import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';

const HiringIcon = ({ size = 22, color = 'currentColor', className }) => (
  <FontAwesomeIcon
    icon={faBriefcase}
    className={className}
    style={{ fontSize: size, color, width: '1em', height: '1em' }}
  />
);

export default HiringIcon;
